var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "#AFAFAF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Funnel detail - Edit",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 2390"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-711 -941H52V705H-711V-941Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-711 -941H52V705H-711V-941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-709.5 705V-941H-712.5V705H-709.5Z",
    fill: "#D9D9D9",
    mask: "url(#path-1-inside-1_0_1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 427320033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 427320030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 427320029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 427320028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 427320008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 427320007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 427320012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 427320005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8438 4.15625V15.4375C14.8438 15.595 14.7812 15.746 14.6698 15.8573C14.5585 15.9687 14.4075 16.0312 14.25 16.0312H4.75C4.59253 16.0312 4.44151 15.9687 4.33016 15.8573C4.21881 15.746 4.15625 15.595 4.15625 15.4375V4.15625H14.8438Z",
    fill: "#ED4855",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.0312 4.15625H2.96875",
    stroke: "#ED4855",
    strokeWidth: 1.8,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.71875 7.71875V12.4688",
    stroke: "#ED4855",
    strokeWidth: 1.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.2812 7.71875V12.4688",
    stroke: "#ED4855",
    strokeWidth: 1.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.8438 4.15625V15.4375C14.8438 15.595 14.7812 15.746 14.6698 15.8573C14.5585 15.9687 14.4075 16.0312 14.25 16.0312H4.75C4.59253 16.0312 4.44151 15.9687 4.33016 15.8573C4.21881 15.746 4.15625 15.595 4.15625 15.4375V4.15625",
    stroke: "#ED4855",
    strokeWidth: 1.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.4688 4.15625V2.96875C12.4688 2.65381 12.3436 2.35176 12.1209 2.12906C11.8982 1.90636 11.5962 1.78125 11.2812 1.78125H7.71875C7.40381 1.78125 7.10176 1.90636 6.87906 2.12906C6.65636 2.35176 6.53125 2.65381 6.53125 2.96875V4.15625",
    stroke: "#ED4855",
    strokeWidth: 1.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 763,
    height: 1646,
    fill: "white",
    transform: "translate(-711 -941)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete-red.6386cba7.svg";
export { ForwardRef as ReactComponent };